import {getFlagEmojiHexFromCountryCode, getGlobeEmojiFexFromContinentCode} from './ClientUtils'
import {UIUtilsEjsVariables} from '../UIUtilsEjsVariables.ts'

export function getCountryOrContinentImageLink(countryCode: string | undefined, continentCode?: string | undefined): string {
    const flagEmojiHexCode = (typeof countryCode === 'string') ? getFlagEmojiHexFromCountryCode(countryCode) : getGlobeEmojiFexFromContinentCode(continentCode)
    if(UIUtilsEjsVariables.isUserOnDiscord) return `/.proxy/jsdelivr/npm/twemoji@11.0.1/2/svg/${flagEmojiHexCode}.svg`
    return `https://cdn.jsdelivr.net/npm/twemoji@11.0.1/2/svg/${flagEmojiHexCode}.svg`
}

const languageToCountryCodeMap: {[key: string]: string} = {
    /* eslint-disable @typescript-eslint/naming-convention */
    en: 'GB',
    af: 'ZA',
    ar: 'SA',
    ca: 'ES',
    cs: 'CZ',
    da: 'DK',
    de: 'DE',
    el: 'GR',
    es: 'ES',
    fi: 'FI',
    fr: 'FR',
    he: 'IL',
    hi: 'IN',
    hu: 'HU',
    it: 'IT',
    ja: 'JP',
    ko: 'KR',
    nl: 'NL',
    no: 'NO',
    pl: 'PL',
    'pt-BR': 'BR',
    'pt-PT': 'PT',
    ro: 'RO',
    ru: 'RU',
    sr: 'RS',
    sv: 'SE',
    th: 'TH',
    tr: 'TR',
    uk: 'UA',
    vi: 'VN',
    'zh-CN': 'CN',
    'zh-TW': 'TW',
    /* eslint-enable @typescript-eslint/naming-convention */
}

export function getLanguageFlagImageLink(languageCode: string): string {
    const countryCode = languageToCountryCodeMap[languageCode] ?? 'GB'
    return getCountryOrContinentImageLink(countryCode)
}
